// calendarDefault.ts — Standard-Kalenderauswahl beim ersten Laden (SP7, T-69).
// Reine Funktion (ohne React), damit die Regel testbar ist.

import type { MailboxAccess } from "../../services/graphMailService";

/**
 * Default-Auswahl = eigener Kalender (vorn) + alle Kalender der Gruppe „eigene“
 * (Postfach-Grants wie cbb@). Quelle ist die KALENDER-Liste (GET
 * calendar/mailboxes) — NICHT die Mail-Liste.
 *
 * T-69: Seit die Kalender-Liste auch Kollegen- und Raumkalender enthält, werden
 * diese NIE vorausgewählt — sie erscheinen nur, wenn jemand sie anhakt. Einträge
 * ohne `kalenderGruppe` (ältere API) gelten als „eigene“.
 */
export function computeDefaultCalendars(
    calendarMailboxes: MailboxAccess[],
    ownAddress: string | null,
): string[] {
    const all = calendarMailboxes
        .filter((m) => m.calendarAccess !== "NONE")
        .filter((m) => (m.kalenderGruppe ?? "eigene") === "eigene")
        .map((m) => m.mailboxAddress);
    const unique = Array.from(new Set(all));
    const own = ownAddress
        ? unique.find((a) => a.toLowerCase() === ownAddress.toLowerCase())
        : undefined;
    return own ? [own, ...unique.filter((a) => a !== own)] : unique;
}
